import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const NewMexico = () => {
  return (
    <StatePropertyTaxPage
      stateName="New Mexico"
      processDescription="Property owners may protest their assessment by filing with the county assessor within 30 days of receiving notice. If unsuccessful, appeals may be filed with the county board of commissioners and subsequently with the state taxation and revenue department."
      noticeOfValueMailed="April"
      noticeOfValueMailedDateExplanation="Assessment notices are typically mailed in April, allowing property owners time to review their assessments before the protest deadline."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="New Mexico assesses property as of January 1 each year. This assessment date ensures consistent property valuations across all counties in New Mexico."
      deadlineExplanation="Property owners have 30 days from receiving the assessment notice to file protests with the county assessor. This deadline is typically in May but depends on when notices are mailed."
    />
  );
};

export default NewMexico;